import type { RouteRecordRaw } from "vue-router"

const partnerPortalRoutes: Array<RouteRecordRaw> = [
  {
    path: "/affiliates",
    name: "affiliates",
    component: () => import("@/views/affiliates/AffiliateList.vue"),
    meta: {
      pageTitle: "Affiliates",
      breadcrumbs: ["Affiliates"],
    },
  },
  {
    path: "/portal-offers",
    name: "portalOffers",
    component: () => import("@/views/portal-offers/OfferList.vue"),
    meta: {
      pageTitle: "Portal Offers",
      breadcrumbs: ["Portal Offers"],
    },
  },
  {
    path: "/portal-offers/requests",
    name: "offerRequests",
    component: () => import("@/views/portal-offers/OfferRequests.vue"),
    meta: {
      pageTitle: "Offer Requests",
    },
  },
  {
    path: "/creatives",
    name: "creative",
    component: () => import("@/views/creative/CreativeList.vue"),
    meta: {
      pageTitle: "Affiliate Creatives",
      breadcrumbs: ["Affiliate Creatives"],
    },
  },
  {
    path: "/creatives/template-offer",
    name: "templateOffer",
    component: () => import("@/views/template-offer/TemplateOfferList.vue"),
    meta: {
      pageTitle: "Creative Offer",
      breadcrumbs: ["Creative Offer"],
    },
  },
  {
    path: "/creatives-template",
    name: "creativeTemplate",
    component: () => import("@/views/creative-template/CreativeTemplateList.vue"),
    meta: {
      pageTitle: "Creative Template",
      breadcrumbs: ["Creative Template"],
    },
  },
  {
    path: "/content/general-information",
    name: "generalInformation",
    component: () => import("@/views/general-information/GeneralInformationList.vue"),
    meta: {
      pageTitle: "General Information",
      breadcrumbs: ["General Information"],
    },
  },
  {
    path: "/content/newest-campaign",
    name: "newestCampaign",
    component: () => import("@/views/newest-campaign/NewestCampaignList.vue"),
    meta: {
      pageTitle: "Campaign News",
      breadcrumbs: ["Campaign News"],
    },
  },
  {
    path: "/content/conference",
    name: "conference",
    component: () => import("@/views/conference/ConferenceList.vue"),
    meta: {
      pageTitle: "Conferences",
      breadcrumbs: ["Conferences"],
    },
  },
  {
    path: "/content/case-study",
    name: "case-study",
    component: () => import("@/views/case-study/CaseStudyList.vue"),
    meta: {
      pageTitle: "Case Study",
      breadcrumbs: ["Case Study"],
    },
  },
  {
    path: "/content/case-study-category",
    name: "case-study-category",
    component: () => import("@/views/case-study/category/CategoryList.vue"),
    meta: {
      pageTitle: "Category",
      breadcrumbs: ["Case Study", "Categories"],
    },
  },
  {
    path: "/content/case-study-tags",
    name: "case-study-tags",
    component: () => import("@/views/case-study/tag/TagList.vue"),
    meta: {
      pageTitle: "Tags",
      breadcrumbs: ["Case Study", "Tags"],
    },
  },
]

export default partnerPortalRoutes
